import React from 'react'
import { ShimmerBadge,
    ShimmerButton,
    ShimmerTitle,ShimmerThumbnail,ShimmerSectionHeader, ShimmerCircularImage, ShimmerText } from 'react-shimmer-effects'


export default function SupportTicketShimmer(){
    return(
        <div className='h-full'>
            <div  className=' px-4 py-[14px]'>
                <div className=" rounded-sm px-5 pt-[30px] pb-[22px]">
                    <div className="flex -mx-1 flex-wrap">
                        <div className="w-1/4 px-1 mb-[30px]">
                            <div className="w-full">
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={1} gap={10} variant="secondary" className="w-[300px]"/></p>
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={1} gap={10} variant="secondary" className="w-[300px]"/></p>
                            </div>
                        </div>
                        <div className="w-1/4 px-1 mb-[30px]">
                            <div className="w-full">
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={1} gap={10} variant="secondary" className="w-[300px]"/></p>
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={1} gap={10} variant="secondary" className="w-[300px]"/></p>
                            </div>
                        </div>
                        <div className="w-1/4 px-1 mb-[30px]">
                            <div className="w-full">
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={1} gap={10} variant="secondary" className="w-[300px]"/></p>
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={1} gap={10} variant="secondary" className="w-[300px]"/></p>

                            </div>
                        </div>
                        <div className="w-1/4 px-1 mb-[30px]">
                            <div className="w-full">
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={1} gap={10} variant="secondary" className="w-[300px]"/></p>
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={1} gap={10} variant="secondary" className="w-[300px]"/></p>

                            </div>
                        </div>
                        <div className="w-1/4 px-1 mb-[30px]">
                            <div className="w-full">
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={1} gap={10} variant="secondary" className="w-[300px]"/></p>
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={1} gap={10} variant="secondary" className="w-[300px]"/></p>

                            </div>
                        </div>
                        <div className="w-1/4 px-1">
                            <div className="w-full">
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={1} gap={10} variant="secondary" className="w-[300px]"/></p>
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={1} gap={10} variant="secondary" className="w-[300px]"/></p>

                            </div>
                        </div>
                        <div className="w-1/4 px-1">
                            <div className="w-full">
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={1} gap={10} variant="secondary" className="w-[300px]"/></p>
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={1} gap={10} variant="secondary" className="w-[300px]"/></p>

                            </div>
                        </div>
                        <div className="w-1/4 px-1">
                            <div className="w-full">
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={1} gap={10} variant="secondary" className="w-[300px]"/></p>
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={1} gap={10} variant="secondary" className="w-[300px]"/></p>

                            </div>
                        </div>

                        <div className="w-1/4 px-1">
                            <div className="w-full">
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={8} gap={10} variant="secondary" className="w-[500px]"/></p>
                            </div>
                        </div>
                        <div className="w-1/4 px-1">
                            <div className="w-full">
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={8} gap={10} variant="secondary" className="w-[500px]"/></p>
                            </div>
                        </div>
                        <div className="w-1/4 px-1">
                            <div className="w-full">
                                <p className="text-2xl font-bold text-[#031624] mt-4">
                                    <ShimmerTitle line={8} gap={10} variant="secondary" className="w-[500px]"/></p>
                            </div>
                        </div>

                    </div>
   
                </div>
            </div>
        </div>
    );

}